import React from "react";
import { motion } from "framer-motion";
import box from "../img/box.jpeg";
import futbol from "../img/futbol.jpeg";
import jimnastik from "../img/jimnastik.jpeg";
import basket from "../img/basket.jpeg";
import tenis from "../img/masa-tenisi.jpeg";
import voleybol from "../img/voleybol.jpeg";

const list = {
	hidden: {
		opacity: 0,
	},
	visible: {
		opacity: 1,
		transition: {
			duration: 1,
			when: "beforeChildren",
			staggerChildren: 0.5,
		},
	},
};

const item = {
	visible: {
		opacity: 1,
		x: 0,
	},
	hidden: {
		opacity: 0,
		x: -100,
	},
};

export default function HomeBranslar() {
	return (
		<div className="container">
			<motion.div
				initial="hidden"
				animate="visible"
				variants={list}
				className="container"
			>
				<div className="row">
					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4">
									<img
										src={futbol}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-5 text-warning">
										FUTBOL
									</h4>
									<div className="p-4">
										<p className="text-justify px-3">
											Alanında uzman ve dinamik antrenör kadrosu.{" "}
											<br /> 4-18 yaş arası lisanslı sporcu olma
											fırsatı.
											<br />
											Spor ahlakı ve spor yapma alışkanlığı
											kazandırma.
										</p>
									</div>
								</div>
							</div>
						</div>
					</motion.div>

					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4">
									<img
										src={basket}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-5 text-warning">
										BASKETBOL
									</h4>
									<div className="p-4">
										<p className="text-justify px-3">
											Alanında uzman ve dinamik antrenör kadrosu.{" "}
											<br /> 4-18 yaş arası lisanslı sporcu olma
											fırsatı.
											<br />
											Spor ahlakı ve spor yapma alışkanlığı
											kazandırma.
										</p>
									</div>
								</div>
							</div>
						</div>
					</motion.div>

					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4">
									<img
										src={voleybol}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-5 text-warning">
										VOLEYBOL
									</h4>
									<p className="px-5 py-4 text-justify">
										Çocuklarımız voleybol öğreniyor. Sizde ailemize
										katılın, temelden öğrenmeye başlayın.
										<br />
										Başlamadan başaramazsın.
										<br />
										Lisanslı sporcu olma şansını kaçırmayın.
									</p>
								</div>
							</div>
						</div>
					</motion.div>
				</div>
				<div className="row">
					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4 text-primary">
									<img
										src={tenis}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-4 text-warning">
										MASA TENİSİ
									</h4>
									<p className="px-5 py-3 text-justify">
										Sporcuya el ayak koordinasyonu, hızlı düşünmeyi,
										dengeyi ve refleks gelişimini katan en önemli
										sporlarımızdan olan masa tenisi, her yaşta ve
										herkesle oynayabileceğiniz dünyanın en iyi
										sporlarından birisidir.
									</p>
								</div>
							</div>
						</div>
					</motion.div>

					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4 text-primary">
									<img
										src={box}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-4 text-warning">
										BOKS
									</h4>
									<p className="px-5 py-3 text-justify">
										Sporcuya disiplin katan ve stres atma kaynağı olan
										boks, vücut kaslarının çalışmasını, el, ayak, göz
										koordinasyonu ve uyumunu sağlayan en önemli
										sporlarımızdan birisidir. Sende pes etme ve
										ailemize katıl.
									</p>
								</div>
							</div>
						</div>
					</motion.div>

					<motion.div variants={item} className="col-lg-4">
						<div className="px-2">
							<div className="paper my-2">
								<div className="d-flex justify-content-center align-items-center pt-4 text-primary">
									<img
										src={jimnastik}
										width="360px"
										height="250px"
										className="radius-20"
										alt="iconlar"
									/>
								</div>
								<div className="row">
									<h4 className="text-center mt-4 text-warning">
										JİMNASTİK
									</h4>
									<p className="px-5 py-3 text-justify">
										Temel eğitim hareketleri ve jimnastik
										eğitimleriniz hafta sonları tüm hızıyla devam
										ediyor. Sizlerde lisanslı sporcu olmak
										istiyorsanız deneme antrenmanlarımıza katılmak
										için iletişime geçiniz.
									</p>
								</div>
							</div>
						</div>
					</motion.div>
				</div>
			</motion.div>
		</div>
	);
}
